import script from "./LlDataTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./LlDataTable.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__